module.exports = __webpack_public_path__ + "img/4d6c709.jpg";